var pug = require("!../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (labelText, value) {pug_html = pug_html + "\u003Cdiv class=\"grid-cell status-column\"\u003E";
if (value) {
var reasons = value.AccountInactiveReasons;
var id = 'AccountInactiveReasonPopup_' + value.Id;
var AccountActivityStatusEnum = value.AccountActivityStatusEnum;
var activityStatus = value.activityStatus;
var isForVNext = value.isForVNext;
if (isForVNext) {
if (!value.Id) {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
else
if (activityStatus === AccountActivityStatusEnum.Errors) {
pug_html = pug_html + "\u003Cspan" + (" class=\"with-account-inactive-reasons clickable\""+" tabindex=\"0\" role=\"button\""+pug.attr("aria-label", labelText, true, true)) + "\u003E\u003Cspan class=\"status-icon status-error iconba iconba-Error\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"error-count\"\u003E" + (pug.escape(null == (pug_interp = reasons.length) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else
if (activityStatus === AccountActivityStatusEnum.Deleted) {
pug_html = pug_html + "\u003Cspan\u003E\u003Cspan class=\"status-icon iconba iconba-Blocked2\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else
if (activityStatus === AccountActivityStatusEnum.Enabled) {
pug_html = pug_html + "\u003Cspan\u003E\u003Cspan class=\"status-icon status-success iconba iconba-Completed\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
}
else {
if (reasons && reasons.length > 0) {
pug_html = pug_html + "\u003Cspan class=\"status_error\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = reasons.length) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan" + (" class=\"status_icon clickable\""+pug.attr("id", id, true, true)+" tabindex=\"0\" role=\"button\""+pug.attr("aria-label", labelText, true, true)) + "\u003E\u003C\u002Fspan\u003E";
}
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"labelText" in locals_for_with?locals_for_with.labelText:typeof labelText!=="undefined"?labelText:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;